<template>
  <div class="container">
    <el-form :inline="true" ref="addForm" :model="addForm" :rules="rules" class="demo-form-inline">
      <el-form-item prop="username">
        <el-input
          v-model="addForm.username"
          maxlength="11"
          placeholder="账号（只能为手机号）"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="addForm.password" type="password" placeholder="密码" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item class="ml">
        <el-button type="primary" @click="userAdd('addForm')">添加</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      max-height="600"
      stripe
    >
      <el-table-column prop="username" label="帐号"/>
      <el-table-column prop="role" label="权限">
        <template slot-scope="{ row: { role:roles }}">
          <span v-for="role in roles" :key="role">
            {{ allMenus.filter(z => z.id+'' === role+'')[0] ? allMenus.filter(z => z.id+'' === role+'')[0].name : '' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="isAdmin" label="操作" width="150">
        <template slot-scope="{ row: { id, username, role, hospital_role, tk_role }}">
          <el-link @click="handleDelete(id, username)" style="margin-right: 5px;">删除</el-link>
          <el-link @click="handleAuth(id, role, hospital_role, tk_role)">授权</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :current-page="pageNumber"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="账户授权"
      :visible.sync="dialogVisible"
    >
      <el-form>
        <el-form-item label="授权" :label-width="formLabelWidth">
          <el-checkbox-group v-model="usrForm.auth">
            <el-checkbox v-for="menu in allMenus" :key="menu.id" :label="menu.id + ''" style="width: 120px">
              {{ menu.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="usrForm.auth.includes('6')" label="陪护订单授权医院" :label-width="formLabelWidth">
          <el-checkbox-group v-model="usrForm.hospital">
            <el-checkbox v-for="hospital in hospitalColumns" :key="hospital.id" :label="hospital.id + ''"
                         style="width: 120px">
              {{ hospital.hospital_name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="usrForm.auth.includes('13')" label="特困供养授权" :label-width="formLabelWidth">
          <el-checkbox-group v-model="usrForm.tk_role">
            <el-checkbox v-for="tk_role in tkMenus" :key="tk_role.id" :label="tk_role.id + ''" style="width: 200px">
              {{ tk_role.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userAdd, userList, userDel, userEdit } from '@/api'
import { isAdmin } from '../utils/util'
import { editUsrRoles, fetchHospitalPList, fetchRolesList } from '../api'

export default {
  data() {
    return {
      addForm: {
        username: '',
        password: '',
        status: false
      },
      formLabelWidth: '143px',
      rules: {
        username: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0-9])|(19[0-9])|(17[0-9])|(16[0-9]))\d{8}$/g,
            message: '请输入正确的手机号'
          }
        ]
      },
      tableData: [],
      usrForm: {
        auth: [],
        hospital: [],
        tk_role: []
      },
      hospitalColumns: [],
      allMenus: [],
      tkMenus: [],
      dialogVisible: false,
      tableLoading: false,
      pageSize: 10,
      pageNumber: 1,
      total: 0
    }
  },
  computed: {
    isAdmin() {
      return isAdmin()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async fetchHospital() {
      await fetchHospitalPList().then(res => {
        if (res.status) {
          this.hospitalColumns = [
            ...res.data.list
          ]
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    init() {
      this.getRolesList()
      this.fetchHospital()
      this.getList()
    },
    async handleAuth(id, role, hospital_role, tk_role) {
      this.usrForm.id = id
      this.usrForm.auth = (role || []).map(i => i + '')
      this.usrForm.hospital = (hospital_role || []).map(i => i + '')
      this.usrForm.tk_role = (tk_role || []).map(i => i + '')
      this.dialogVisible = true
    },
    async getRolesList() {
      const res = await fetchRolesList()
      this.allMenus = Object.values(res)
      const info = Object.values(res).filter(i => Number(i.id) === 13)[0].child
      this.tkMenus = Object.values(info)
    },
    async handleSave() {
      const { id, auth, hospital, tk_role } = this.usrForm
      const res = await editUsrRoles({
        id,
        role: auth.join(','),
        hospital_role: hospital.join(','),
        tk_role: tk_role.join(',')
      })
      if (res.status) {
        this.getList()
        this.dialogVisible = false
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pageNumber = val
      this.getList()
    },
    userAdd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = {
            ...this.addForm
          }
          if (this.addForm.hospital && this.addForm.hospital.length > 0) {
            params.hospital_role = this.addForm.hospital.join(',')
          }
          params.status = params.status ? 2 : 1
          userAdd(params).then(res => {
            if (res.status) {
              this.$message.success('添加成功')
              this.resetForm(formName)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    getList() {
      this.tableLoading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: this.pageNumber
      }
      userList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
            this.tableData.forEach(user => {
              user.status = user.status !== 1
              user.is_finance = user.is_finance === 1
              user.is_hospital = user.is_hospital === 1
            })
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    changeStatus(index, id, status, changeKey = 'status') {
      const params = {
        id,
        [changeKey]: changeKey === 'status' ? status ? 2 : 1 : status ? 1 : 0
      }
      userEdit(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
        } else {
          this.tableData[index].status = !status
          this.$message.error(res.msg)
        }
      })
    },
    handleDelete(id, username) {
      this.$confirm(`确定删除账号${username}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userDel({
            id
          }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    width: 100%;

    .imgbox {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .litimg {
        width: 42px;
        object-fit: cover;
        cursor: zoom-in;
      }
    }

    .picture {
      width: 100%;
    }

    .block {
      text-align: center;
    }

    .el-pagination {
      margin-top: 20px;
    }
  }
</style>
